import { InterfaceIcon, getSvgIcon } from '@helpers/icons';
import { getSrcs, imageUrl } from '@helpers/image';
import { Device, until } from '@helpers/media';
import * as React from 'react';
import S from './TestimonialCard.styles';
const TestimonialCard = (props) => {
    const imageSrc = props.quoteeImage ? getSrcs(props.quoteeImage, 232, 116, 2, 1 / 1) : null;
    const isPortrait = (props.companyLogo?.height ?? 0) > (props.companyLogo?.width ?? 0);
    return (React.createElement(S.Container, { "data-variant": props.variant },
        React.createElement(S.ImageWrapper, null,
            imageSrc && (React.createElement(S.Image, { src: imageSrc.src, srcSet: imageSrc.srcSet, loading: "lazy", alt: props.quoteeName, sizes: `${until(Device.TabletLarge)} 116px, 232px` })),
            React.createElement(S.Icon, null, getSvgIcon(InterfaceIcon.Quote))),
        React.createElement(S.ContentWrapper, null,
            props.companyLogo && (React.createElement(S.CompanyLogo, { "data-portrait": isPortrait },
                React.createElement(S.Image, { src: imageUrl(props.companyLogo, { height: isPortrait ? 128 : 64 }), loading: "lazy", alt: props.companyLogo.altText }))),
            React.createElement(S.Quote, null, props.quote),
            props.quoteeName && (React.createElement(S.Quotee, null,
                props.quoteeName,
                props.quoteeTitle && React.createElement(S.JobTitle, null, props.quoteeTitle))))));
};
export default TestimonialCard;
